import { action } from 'satcheljs';

export const onMenuCollapsedChanged = action('onMenuCollapsedChanged', (collapsed: boolean) => ({ collapsed }));
